export default __webpack_public_path__ + "static/media/progress-2-guest.cf56d064.svg";